import React, { SVGProps } from 'react'

export const SecondActiveLeftSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.546 14.933C-2.658 30.101 8.992 36 16 36V5C7.235 7.241 1.496 10.435.546 14.933Z"
    />
  </svg>
)
